import React from "react";
import { Container, Typography, Box, Alert, Divider, Chip, Paper, Stack } from "@mui/material";
import SectionTitle from "../../components/layouts/others/title-section.layout";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle, faChartLine, faGavel, faUsers, faCoins, faInfoCircle, faBook } from "@fortawesome/free-solid-svg-icons";

const POST20240320: React.FC = () => {
    return (
        <Container sx={{ mb: 5 }}>
            <SectionTitle title="ESPACE INFORMATIONS DES HABITANTS" />
            <Box mt={3}>
                <Typography
                    variant="h6"
                    fontWeight={700}
                    align="center"
                    gutterBottom
                    color="primary"
                >
                    Abandon du projet de crèche&nbsp;!
                </Typography>
            </Box>

            <Paper elevation={2} sx={{ p: 3, mt: 3 }}>
                <Stack spacing={2}>
                    <Alert icon={<FontAwesomeIcon icon={faExclamationTriangle} />} severity="error" sx={{ fontWeight: 600 }}>
                        Le Maire affirme que «&nbsp;ses opposants&nbsp;» ont fait capoter son projet de crèche au Bois de la source. Mais la réalité est toute autre.
                    </Alert>

                    <Typography variant="body1">
                        La véritable raison&nbsp;<b>de l'abandon</b>&nbsp;: un
                        <b style={{ color: "#d32f2f" }}> manque de financement</b>. Ce crash financier est directement imputable au Maire, qui n’en prend pas la responsabilité et préfère blâmer autrui, se posant même en victime.
                    </Typography>

                    <Divider textAlign="left" sx={{ my: 2 }}><Chip icon={<FontAwesomeIcon icon={faChartLine} />} label="Un bilan financier dégradé" color="primary" /></Divider>
                    <Typography variant="body2">
                        <ul>
                            <li>Fin 2018&nbsp;: fonds propres et épargne brute permettaient d’envisager tous les projets.</li>
                            <li>2024&nbsp;: les caisses sont vides, la dette a été multipliée par 10 entre 2021 et 2026 (<b>cf.&nbsp;ROB2024</b>), alors que&nbsp;:
                                <ul>
                                    <li>Crèche, maison médicale, gymnase&nbsp;: <b>toujours à l’arrêt ou à peine lancés</b></li>
                                    <li>Médiathèque&nbsp;: juste une dalle, financée par <b>1M€ d’emprunt</b> (2022)</li>
                                </ul>
                            </li>
                            <li>Taxe foncière&nbsp;: +9&nbsp;% en 2023, +26&nbsp;% attendus en 2024&nbsp;! Pourtant, cela ne suffira pas à rétablir durablement les finances municipales.</li>
                        </ul>
                    </Typography>

                    <Divider textAlign="left" sx={{ my: 2 }}><Chip icon={<FontAwesomeIcon icon={faUsers} />} label="Méthodes critiquées" color="secondary" /></Divider>
                    <Typography variant="body1">
                        La responsabilité de l’adjointe à la Petite enfance est engagée, n’ayant pas pris les devants avant le crash. <br />
                        Le Maire, focalisé sur la médiathèque, n’a pas su écouter les alternatives&nbsp;: <b>aucune proposition de site alternatif examinée</b>, le choix imposé par le Maire a fait l’unanimité contre lui.
                    </Typography>

                    <Typography variant="body2">
                        <FontAwesomeIcon icon={faBook} style={{ marginRight: 5 }} />
                        Les méthodes déjà contestées lors de l’affaire du City-stade se répètent, produisant les mêmes erreurs et retards.
                    </Typography>

                    <Divider textAlign="left" sx={{ my: 2 }}><Chip icon={<FontAwesomeIcon icon={faGavel} />} label="Conséquences juridiques et urbaines" /></Divider>
                    <Typography variant="body2">
                        <FontAwesomeIcon icon={faCoins} style={{ color: "#d32f2f", marginRight: 5 }} />
                        Perte de temps et d’argent (honoraires) et
                        <b>&nbsp;épée de Damoclès&nbsp;SRU&nbsp;!</b>&nbsp;: Si les objectifs SRU ne sont pas atteints en 2025, le préfet pourrait faire préempter la parcelle du Bois de la source et imposer la construction de logements sociaux.
                    </Typography>

                    <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                        Le Maire acceptera-t-il de conserver nos espaces verts&nbsp;? Protéger ces parcelles par leur classement en zones naturelles ou ENS&nbsp;?
                    </Typography>

                    <Divider sx={{ my: 2 }}>Notre proposition</Divider>
                    <Alert icon={<FontAwesomeIcon icon={faUsers} />} severity="info" sx={{ fontWeight: 600 }}>
                        Nous proposons d’ouvrir un
                        <b> large débat public </b>
                        sur l’avenir du Bois de la source. Exprimons-nous pour bâtir ensemble un projet partagé&nbsp;!
                    </Alert>
                </Stack>
            </Paper>
        </Container>
    );
};

export default POST20240320;